import { render, staticRenderFns } from "./Financial-collection.vue?vue&type=template&id=276b3966&scoped=true&"
import script from "./Financial-collection.vue?vue&type=script&lang=js&"
export * from "./Financial-collection.vue?vue&type=script&lang=js&"
import style0 from "./Financial-collection.vue?vue&type=style&index=0&id=276b3966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276b3966",
  null
  
)

export default component.exports